import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showSaveRole } from '../actions';

const DuplicateRoleAction = ({
  code,
  category,
  readStatus,
  readErrors,
  isEditing,
  duplicateRole,
}) => (
  <RibbonMenu
    icon="clone"
    name="duplicate"
    message="actions.duplicate"
    onClick={() => duplicateRole(code, category)}
    className="aridhia-duplicate-role-action"
    disabled={isEditing || readStatus !== states.SUCCESS || firstError(readErrors) !== null}
  />
);

const mapStateToProps = ({
  roles: { roles },
}, { category, code }) => {
  const role = findResult(roles, category, code);

  return {
    readErrors: role ? role.readErrors : [],
    readStatus: role ? role.readStatus : states.NONE,
    isEditing: role ? role.isEditing : false,
  };
};

const mapDispatchToProps = {
  duplicateRole: showSaveRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateRoleAction);
